// extracted by css-extract-rspack-plugin
var _1 = "container__PRvHp";
var _2 = "description__C2_yv";
var _3 = "description__details__QaGjQ";
var _4 = "description__title__vUsaU";
var _5 = "img-container__XsO5L";
var _6 = "mobile-clear__edEoa";
export { _1 as "container", _2 as "description", _3 as "description__details", _4 as "description__title", _5 as "img-container", _6 as "mobile-clear" }
export default { "container": _1, "description": _2, "description__details": _3, "description__title": _4, "img-container": _5, "mobile-clear": _6 }
